// C:\Users\aleja\Code\inventory_analytics\src\front\src\pages\layout.js

import RepairableSpareParts from "./RepairableSpareParts";
import RepairableSparePartDetail from "./RepairableSparePartDetail";
import RepairableSparePartForm from "./RepairableSparePartForm";
import RepairableSparePartsDeleted from "./RepairableSparePartsDeleted";

import React, { useEffect, useContext } from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Context } from "../store/appContext";

import Navbar from "../components/Navbar";

import Home from "./Home";
import Dashboard from "./dashboard";
import AddInventoryData from "../components/AddMonthlyInventoryData.jsx";
import Login from "../components/Login.jsx";
import ProtectedRoute from "../components/ProtectedRoute.jsx";

import ChangePassword from "./ChangePassword";
import UserManagement from "../pages/UserManagement.jsx";
import UserActivity from "../pages/UserActivity.jsx";
import UserActivityDashboard from "../pages/UserActivityDashboard.jsx";
import ImportBatches from "./ImportBatches.jsx";
import ImportBatchDetail from "./ImportBatchDetail.jsx";
import WarehouseExcelImport from "./WarehouseExcelImport.jsx";
import WarehouseCostAnalytics from "./WarehouseCostAnalytics.jsx";
import SuppliersCatalog from "./SuppliersCatalog.jsx";
import SupplierDetail from "./SupplierDetail.jsx";
import PartsCatalog from "./PartsCatalog.jsx";
import MachineCatalog from "./MachineCatalog.jsx";
import MachineDetail from "./MachineDetail.jsx";
import PartDetail from "./PartDetail.jsx";
import OrmaCatalog from "./OrmaCatalog.jsx";
import OrmaCatalogAdmin from "./OrmaCatalogAdmin.jsx";
import OrmaWarehouseValuation from "./OrmaWarehouseValuation.jsx";
import PendingPartExits from "./PendingPartExits.jsx";
import Toast from "../components/Toast";

const AppRoutes = () => {
  const { actions, store } = useContext(Context);

  useEffect(() => {
    actions.checkAuth();
  }, []);

  useEffect(() => {
    if (store.isAuthenticated && store.role !== "scanner") {
      actions.getInventoryHistory();
    }
  }, [store.isAuthenticated, store.role]);

  return (
    <>
      <Navbar />

      <div className="mt-4">
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/login" element={<Login />} />

          <Route
            path="/panel"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]} redirectTo="/import-batches">
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-inventory-data"
            element={
              <ProtectedRoute role="admin" redirectTo="/import-batches">
                <AddInventoryData />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute role="admin" redirectTo="/import-batches">
                <UserManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-activity"
            element={
              <ProtectedRoute role="admin" redirectTo="/import-batches">
                <UserActivity />
              </ProtectedRoute>
            }
          />

          <Route
            path="/imports/warehouse-excel"
            element={
              <ProtectedRoute role="admin" redirectTo="/import-batches">
                <WarehouseExcelImport />
              </ProtectedRoute>
            }
          />

          <Route
            path="/import-batches"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <div className="container mt-4">
                  <div className="row justify-content-center">
                    <div className="col-lg-9">
                      <ImportBatches />
                    </div>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/import-batches/:batch_id"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <ImportBatchDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/warehouse-cost-analytics"
            element={
              <ProtectedRoute role="admin" redirectTo="/import-batches">
                <WarehouseCostAnalytics />
              </ProtectedRoute>
            }
          />

          <Route
            path="/suppliers-catalog"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <SuppliersCatalog />
              </ProtectedRoute>
            }
          />

          <Route
            path="/suppliers/:supplier_id"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <SupplierDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/parts-catalog"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <PartsCatalog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/machines"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <MachineCatalog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/machines/:machine_id"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <MachineDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/parts/:material_id"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <PartDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/orma-catalog"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <OrmaCatalog />
              </ProtectedRoute>
            }
          />

          <Route
            path="/orma-catalog/admin"
            element={
              <ProtectedRoute role="admin" redirectTo="/orma-catalog">
                <OrmaCatalogAdmin />
              </ProtectedRoute>
            }
          />

          <Route
            path="/orma-valuation"
            element={
              <ProtectedRoute roles={["admin", "tecnico"]}>
                <OrmaWarehouseValuation />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pending-part-exits"
            element={
              <ProtectedRoute roles={["admin", "tecnico", "scanner"]}>
                <PendingPartExits />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-activity-analytics"
            element={
              <ProtectedRoute role="admin" redirectTo="/import-batches">
                <UserActivityDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          <Route
            path="*"
            element={
              store.role === "scanner" ? (
                <Navigate to="/pending-part-exits" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        <Route
          path="/reparable-spare-parts"
          element={
            <ProtectedRoute roles={["admin", "tecnico"]}>
              <RepairableSpareParts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reparable-spare-parts/new"
          element={
            <ProtectedRoute roles={["admin", "tecnico"]}>
              <RepairableSparePartForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reparable-spare-parts/deleted"
          element={
            <ProtectedRoute role="admin" redirectTo="/reparable-spare-parts">
              <RepairableSparePartsDeleted />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reparable-spare-parts/:id"
          element={
            <ProtectedRoute roles={["admin", "tecnico"]}>
              <RepairableSparePartDetail />
            </ProtectedRoute>
          }
        />
        </Routes>
      </div>

      {/* Toast global del sistema */}
      <Toast
        message={store.toast.message}
        type={store.toast.type}
        onClose={actions.clearToast}
      />
    </>
  );
};

const Layout = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default Layout;
